/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import HospitalOPBillItem from './hospital-op-bill-item';
import HospitalOPBillItemDetail from './hospital-op-bill-item-detail';
import HospitalOPBillItemUpdate from './hospital-op-bill-item-update';
import HospitalOPBillItemDeleteDialog from './hospital-op-bill-item-delete-dialog';

const HospitalOPBillItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<HospitalOPBillItem />} />
    <Route path="new" element={<HospitalOPBillItemUpdate />} />
    <Route path=":id">
      <Route index element={<HospitalOPBillItemDetail />} />
      <Route path="edit" element={<HospitalOPBillItemUpdate />} />
      <Route path="delete" element={<HospitalOPBillItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default HospitalOPBillItemRoutes;
